import React from "react";
import logo from '../../assets/logo/logo.png';
import getIcon from "../../utils/Icon";

export default function Avatar({ width, height , label ,icon }) {
    return (
        <div 
            style={{ 
                width: `${width}px`, 
                height: `${height}px`,
                position: 'relative'
            }} 
            className="flex-shrink-0"
        >
            <div
                style={{ 
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    overflow: 'hidden'
                }}
            >
                <img 
                    src={icon ? icon : logo} 
                    alt="Logo" 
                    className="w-full h-full object-cover"
                    style={{ 
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                    }}
                />
            </div>
            {
                label && <img 
                    src={getIcon(label)} 
                    className={'absolute top-0 -right-1 rounded-full object-cover'} 
                    style={{ 
                        width: `${width * 0.35}px`,
                        height: `${height * 0.35}px`,
                        borderRadius: '50%',
                        zIndex: 10
                    }}
                />
            }
        </div>
    );
}
